module.exports = __webpack_public_path__ + "files/012cb71c1c0e1b067ba7aeb7e6ce3f5e.png";